import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import DatePicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import moment from 'moment';
import Select from '@shared/components/forms/inputs/select/select.vue';
import { InvoiceGenerationFormModel } from '@accounting/interfaces/invoice';
import { CenterSetting } from '@core/interfaces/center-setting';

@Component({
  name: 'bpc-invoice-generation-form',
  components: {
    'bpc-date-picker': DatePicker,
    'bpc-input': Input,
    'bpc-entity-select': EntitySelect,
    'bpc-select': Select,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class InvoiceGenerationForm extends Vue {
  // PROPS
  @Prop(Boolean) disabledFields: boolean;
  @Prop(Object) errors;
  @Prop(Array) readonly accountingJournalsType: string[];
  @Prop({ type: Boolean, default: false }) readonly showProcessAllOptions: boolean;
  @Prop({ type: Number, default: 0 }) readonly totalEntities: number;
  @Prop({ type: Number, default: 0 }) readonly totalSelectedEntities: number;

  // DATA
  public entity: string = 'invoice';
  public selectConfigName: string[] = ['invoice-generation-select'];
  public permissionEntityNameToUse: string = 'invoices';
  public formModel: InvoiceGenerationFormModel = {
    accounting_journal: null,
    accounting_journal_id: null,
    invoice_type: null,
    invoice_period_start: moment(new Date())
      .startOf('month')
      .format('YYYY-MM-DD'),
    invoice_period_end: moment(new Date())
      .endOf('month')
      .format('YYYY-MM-DD'),
    process_all: false,
  };

  invoiceGenerationRequestSent = false;
  isGeneratingInvoices = false;

  public labelInputAttributes = {
    for: 'global__',
    cols: 12,
  };

  public statusOptions: object[] = [
    { text: 'global.status.draft', value: 'draft' },
    { text: 'global.status.to_pay', value: 'to_pay' },
  ];

  public statusValueToColor: object[] = [
    { value: 'draft', color: 'border-0 text-primary bg-info' },
    { value: 'to_pay', color: 'border-0 text-white bg-warning' },
  ];

  public errorCustom: AnyEntity = {};

  // COMPUTED

  get centerSetting(): CenterSetting {
    return this.$store.getters['centerSettings/centerSettings'];
  }

  get accountingJournalSelectfilters() {
    return [
      {
        filterField: 'status',
        value: 'active',
      },
      {
        filterField: 'type',
        value: this.accountingJournalsType,
      },
    ];
  }

  // LIFECYCLE HOOKS
  mounted() {
    this.cleanFormModel();
  }

  // METHODS
  onLoadedAccountingJournals(items) {
    if (items && items.length === 1) {
      this.onChangeAccountingJournal(items[0]);
    }
  }

  onCleanErrors(input) {
    this.errorCustom[input] = null;
  }

  async onChangeAccountingJournal(accountingJournal) {
    this.cleanFormModel();
    if (accountingJournal) {
      this.formModel.accounting_journal = accountingJournal;
      this.formModel.accounting_journal_id = accountingJournal.id;
      this.formModel.invoice_type = accountingJournal.type;
      const invoiceData = {
        status: 'draft',
        type: this.formModel.invoice_type,
      };
      this.$emit('invoice-status-changed', invoiceData);
    }
  }

  // Format the recieved errors from backend and set it in the correct way for frontend
  setErrors() {
    if (this.errors) {
      this.errorCustom = Object.keys(this.errors).reduce((res, key) => {
        res[key] = this.errors[key][0] || null;
        return res;
      }, {});
    }
  }

  public cleanFormModel() {
    this.errorCustom = {};
    this.formModel.accounting_journal = null;
    this.formModel.accounting_journal_id = null;
    this.formModel.invoice_type = null;
    this.formModel.process_all = false;

    // this.formModel.invoice_period_start = null;
    // this.formModel.invoice_period_end = null;
  }

  // WATCHERS

  @Watch('errors', { immediate: true, deep: true })
  onErrorsChange() {
    this.setErrors();
  }
}
